// ProductItemsList.jsx
import React from 'react';
import KitchenReferenceList from './KitchenReferenceList';

const ProductItemsList = (props) => {
  return <KitchenReferenceList referenceType="product-items" {...props} />;
};

export default ProductItemsList;
